import alt from 'alt.js';

export class PageActions {

    initializeModel(model, modelId) {
        return { model, modelId };
    }

    refreshEditor(pageId) {
        return pageId;
    }

    setHighlightedElement(elementId, modelId) {
        return { elementId, modelId };
    }

    savePage(modelId, pageId, id, flowKey) {
        return { modelId, pageId, id, flowKey };
    }

    editPageData(property, value, modelId) {
        return { property, value, modelId };
    }

    changePageContext(flowId, modelId) {
        return { flowId, modelId };
    }

    removeContainer(containerId, modelId) {
        return { containerId, modelId };
    }

    removeComponent(componentId, modelId) {
        return { componentId, modelId };
    }

    addContainer(type, name, order, parentId, modelId) {
        return { type, name, order, parentId, modelId };
    }

    cloneContainer(containerId, modelId) {
        return { containerId, modelId };
    }

    addComponent(modelId, callback, response) {
        const command = manywho.utils.getObjectDataProperty(response.outputs, 'Command').contentValue;
        if (!manywho.utils.isEqual(command, 'cancel', true)) {
            return { response, modelId };
        }

        return null;
    }

    changeContainerType(id, type, modelId) {
        return { id, type, modelId };
    }

    setContainer(container, modelId) {
        return { container, modelId };
    }

    setComponent(component, modelId) {
        return { component, modelId };
    }

    editComponent(command, component, order, modelId) {

        const droppedOn = command === 'new' ? component.pageContainerId : null;
        return {
            droppedOn,
            droppedOrder: order,
            editing: {
                type: 'COMPONENT',
                id: component.id,
                componentType: component.componentType,
                header: `${component.componentType}: ${component.developerName}`,
                flow: 'Page Component',
                command,
            },
            modelId,
        };
    }

    editComponentDone(modelId) {
        return {
            droppedOn: null,
            droppedOrder: null,
            editing: {
                type: null,
                header: 'Page',
                id: null,
                flow: null,
                componentType: null,
                command: null,
            },
            modelId,
        };
    }

    editContainer(command, container, modelId) {

        return {
            editing: {
                type: 'CONTAINER',
                id: container.id,
                header: `${container.containerType}: ${container.developerName}`,
                flow: 'Page Container',
                containerType: container.containerType,
                command,
            },
            modelId,
        };
    }

    editContainerDone(modelId) {
        return {
            editing: {
                type: null,
                header: 'Page Layout',
                id: null,
                flow: null,
                containerType: null,
                command: null,
            },
            modelId,
        };
    }

    togglePreview(modelId) {
        return modelId;
    }

    delete(modelId) {
        return modelId;
    }

    setFlows(flows, modelId) {
        return { flows, modelId };
    }

    setPageConditions(pageConditions, modelId) {
        return { pageConditions, modelId };
    }

    setConfigHeader(header, modelId) {
        return { header, modelId };
    }

    setEditingType(type, modelId) {
        return { type, modelId };
    }

    moveItem(modelId, item, source, target, sibling, isBefore) {
        return { modelId, item, source, target, sibling, isBefore };
    }

    moveItemUp(modelId, item, container, order) {
        return { modelId, item, container, order: order - 1, isBefore: true };
    }

    moveItemDown(modelId, item, container, order) {
        return { modelId, item, container, order: order + 1, isBefore: false };
    }

    clear() {
        return true;
    }
}

export default alt.createActions(PageActions);
